<template>
  <div class="container" />
</template>


<script>
// import {
//     mapActions,
//     mapGetters
// } from "vuex";

export default {
    // components: {

    // },

    // setup() {

    // },

    // data() {
    //     return {
    //         td : this.$route.query.td ?? ''
    //     };
    // },
    // computed: {
    //     ...mapGetters(["isSilentLogin", "user"])

    // },

    // watch: {
    //     user: function () {

    //         if (this.user != 'undefined') {

    //             
    //             localStorage.setItem('user', JSON.stringify(this.user))
    //             this.$router.push({
    //                 path: `/appointment/detail/${this.user.appointment_id}`,
    //                 query : {flow_type :this.$route.query.flow_type}
    //             });
    //         }

    //     },
    // },

    // mounted() {
    //     if (this.$route.query.td) {

    //         
    //         this.onSilentLogin()
    //     } else {
    //         this.$router.replace({
    //             name: 'login'
    //         })
    //     }
    // },

    // methods: {
    //     ...mapActions(["silentLogin"]),
    //     onSilentLogin() {
    //         this.silentLogin({
    //             td: this.$route.query.td
    //         });
    //     },
    // },
};
</script>
